<script lang="ts">
    import cn from 'classnames';
    import { configService } from '$lib/services';

    import { Dialogs } from '@components/layout/dialogs';
    import { Footer } from '@components/layout/footer';
    import { Header } from '@components/layout/header';
    import { globalStore } from '@components/stores';
    import { dialogStore } from '@components/ui/dialog';
    import { Country } from '@shared/types';
    import { Font, FontTypes } from '@uikit/font';

    import s from '../error.module.css';

    export let country: Country;
</script>

<div class={cn(s.app, { [s.desktop]: $globalStore.isDesktopSite, [s.geoBlocked]: true })}>
    <Header isDesktop={$globalStore.isDesktopSite} />
    <div class={cn(s.root, { [s.desktop]: $globalStore.isDesktopSite }, s.geoBlockedContent)}>
        <div class={cn(s.content)}>
            <Font
                type={FontTypes.Type.body}
                tagName={FontTypes.TagName.div}
                className={cn(s.title)}
            >
                Dear users,
            </Font>
            <Font
                type={FontTypes.Type.body}
                tagName={FontTypes.TagName.div}
                className={cn(s.title)}
            >
                Our service is no longer available in {country}.
                We appreciate your understanding and thank you for your trust and support.
            </Font>
            <Font
                type={FontTypes.Type.body}
                tagName={FontTypes.TagName.div}
                className={cn(s.title)}
            >
                Sincerely,<br />
                Flirtify Team
            </Font>
        </div>
    </div>
    <Footer isOperator={false} />

    {#if !configService.get('isUnsupportedDevice')}
        {#if $dialogStore.isOpened}
            <Dialogs />
        {/if}
    {/if}
</div>